module.exports = __webpack_public_path__ + "img/discuss-screen-es.2e834664.png";